
import * as handlebars_family from "../handlebars_family.ts";
import "../layout/layout_modal.mustache";
import "../widget/action-menu.ts";
const TPL = handlebars_family.addTemplate("features/aiinbox_modal",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <form class=\"modal V4\"><div class=\"title\"><icon class=\"modal-close\" data-fw-onclick=\"modalclose\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_close",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":123},"end":{"line":1,"column":145}}}))
    + "</icon> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"aiinbox.title",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":153},"end":{"line":1,"column":179}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"current") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":180},"end":{"line":1,"column":303}}})) != null ? stack1 : "")
    + " </div><div class=\"content\"><img src=\"images/illustration_email_event_import.svg\" style=\"border-radius:var(--space)\"/><p class=\"sub1\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"aiinbox.description",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":437},"end":{"line":1,"column":469}}})) != null ? stack1 : "")
    + " <a data-fw-onclick=\"aiinboxlearnmore\" style=\"color:var(--fwPrimary)\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"aiinbox.learnmore",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":539},"end":{"line":1,"column":569}}})) != null ? stack1 : "")
    + "</a></p> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"current") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":578},"end":{"line":1,"column":839}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"current") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":1,"column":840},"end":{"line":1,"column":1020}}})) != null ? stack1 : "")
    + " </div></form> ";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon data-widget=\"widget/action-menu\" data-key=\"aiinboxmenu\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_more_vertical",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":258},"end":{"line":1,"column":288}}}))
    + "</icon> ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <line data-fw-onclick=\"aiinboxcopy\" class=\"border-pane\" style=\"background-color:var(--fwSurfaceContainerLower);text-align:center;color:var(--fwPrimary)\"> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"current") : depth0), depth0))
    + "@"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"domain") : depth0), depth0))
    + " </line><p class=\"sub4\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"aiinbox.copyhelp",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":798},"end":{"line":1,"column":827}}})) != null ? stack1 : "")
    + "</p> ";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <button data-fw-onclick=\"aiinboxedit\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"aiinbox.edit",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":894},"end":{"line":1,"column":919}}})) != null ? stack1 : "")
    + "</button> ";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <button data-fw-onclick=\"aiinboxedit\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"aiinbox.create",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":976},"end":{"line":1,"column":1003}}})) != null ? stack1 : "")
    + "</button> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"layout/layout_modal"),depth0,{"name":"layout/layout_modal","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
export default TPL;